import React, {useState, useRef /*, useContext */ } from 'react';
import { Button, Modal, Form, Input } from 'antd';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';

function UpdateDecklists(props) {
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);

    function toggleModal() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        setIsActive(false);
        form.resetFields();
    }

    async function onFinish(values) {
        const tournament = props.tournament;
        tournament.decklist = values.decklist;

        const response = await fetch(api.tournaments().update().href, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(tournament) // body data type must match "Content-Type" header
        })
        .then((data) => data.json())

        window.location.reload(false);
    }

    return(
            <div>
                <Modal title="Update Decklists" open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} maskClosable={false} cancelText="Cancel" okText="Update">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }} initialValues={{ "decklist": props.tournament.decklist }}>
                    <Form.Item label="Decklists" name="decklist">
                        <Input placeholder="Link to decklist page" />
                    </Form.Item>
                    {/* <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                            Aggiungi
                        </Button>
                    </Form.Item> */}
                </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal}>
                    UPDATE DECKLIST
                </Button>
            </div>
    )
}

export default UpdateDecklists;